import { z } from "zod";

export const stripeConnectStatusEnum = z.enum([
  "not_connected",
  "restricted",
  "connected",
]);

export type StripeConnectStatus = z.infer<typeof stripeConnectStatusEnum>;
